import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	Row,
	BreadcrumbItem,
	CardBody,
	CardText,
} from "reactstrap";
import { MetaTags } from "react-meta-tags";
import { Link } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import ResaleService from "services/Website/ResaleService";
import { SuccessOk } from "configs/statusCode";
import { useSelector } from "react-redux";
import "./styles.scss";
import "assets/scss/website/app.scss";
import "react-rangeslider/lib/index.css";
import { useTranslation } from "react-i18next";
import CallModal from "components/Website/Cards/CallModal";
import Skeleton from "components/Website/Skeleton";
import http from "services/HttpService";
import MessageModal from "components/Website/Cards/MessageModal";
import CheckAvailabilityModal from "components/Website/Cards/CheckAvailabilityModal";
import BuyUnitModal from "components/Website/Cards/BuyUnit";

const ResaleBuyDetailsPage = (props) => {
	const { id } = props.match.params;
	const { t } = useTranslation();
	const [resaleDetails, setResaleDetails] = useState({});
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const resaleService = new ResaleService();
	const [callModal, setCallModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);
	const [DetailsLoading, setDetailsLoading] = useState(true);
	const [loading, setLoading] = useState(false);
	const [checkAvailabilityModal, setCheckAvailabilityModal] = useState(false);
	const [checkAvailability, setCheckAvailability] = useState(0);
	const [buyModal, setBuyModal] = useState(false);

	useEffect(() => {
		http.setLang();
		resaleService.find(id).then((response) => {
			if (response && response.status === SuccessOk) {
				setResaleDetails(response.data);
				setDetailsLoading(false);
				setCheckAvailability(response.data.check_availability);
			}
		});
	}, []);

	const handleCheckAvailability = () => {
		setLoading(true);
		let data = {
			resale_id: resaleDetails.id,
		};
		resaleService.checkResale(data).then((res) => {
			if (res && res.status === SuccessOk) {
				setCheckAvailability(1);
				setCheckAvailabilityModal(true);
				setLoading(false);
			}
		});
	};

	if (DetailsLoading) {
		return <Skeleton.ProprtyBuyDetails history={props.history} />;
	}

	return (
		<div className="websitPages">
			<MetaTags>
				<title>{t("resale details")}</title>
			</MetaTags>
			<div className="pt-10rem">
				<Container fluid className="px-lg-5 px-3 pb-5">
					{/* <ol className="breadcrumb ps-0 mb-2">
            <BreadcrumbItem>
              <Link to="/">{t("home")}</Link>
            </BreadcrumbItem>
            <BreadcrumbItem style={{ cursor: "pointer" }}>
              <Link to={`/resales`}>{t("results")}</Link>
            </BreadcrumbItem>
            <BreadcrumbItem style={{ cursor: "pointer" }}>
              <Link to={`/resale-view/${resaleDetails.id}`}>
                {t("Property Details")}
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>{t("Payment Process")}</BreadcrumbItem>
          </ol> */}
					<p
						className="font-size-32 text-primary"
						dangerouslySetInnerHTML={{
							__html: t("Resale Process"),
						}}></p>
					<Row className="mt-3 p-2">
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-14 mb-0 text-color">Unit Code</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{resaleDetails?.name[`${AuthData.lang}`]
										? resaleDetails.name[`${AuthData.lang}`]
										: resaleDetails.name?.en}
								</h5>
							</div>
						</Col>
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-14 mb-0 text-color">Location</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{!!resaleDetails.area?.name ? resaleDetails.area?.name : "-"}
								</h5>
							</div>
						</Col>
						{resaleDetails.in_compound && (
							<Col md={3} className="my-2 ">
								<p className="font-size-14 mb-0 text-color">Compound Name</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{resaleDetails.compound?.name}
								</h5>
							</Col>
						)}
						{/* <Col md={3}>
                <div className="details-box">
                    <p className="font-size-14 mb-0 text-color">Built Up Area</p>
                    <h5 className="fw-bold">{parseInt(resaleDetails?.total_built_up_area)} sqm</h5>                                        </Col>
                </div>
            </Col> */}
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-14 mb-0 text-color">Price</p>
								<h5 className="fw-bold text-primary mb-0 font-size-18 mt-1">
									{toCurrency(resaleDetails?.payment_plan?.total_price)}{" "}
									{currency?.currency_code}
								</h5>
							</div>
						</Col>
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-14 mb-0 text-color">Payment Method</p>
								<h5 className="text-primary">
									{resaleDetails?.payment_plan?.payment_method ===
									"Owner Installment"
										? t("Installment with Owner")
										: resaleDetails?.payment_plan?.payment_method === "Cash"
										? t("only cash")
										: t("installment")}
								</h5>
							</div>
						</Col>
						<Col md={3} className="my-2 ">
							<div className="details-box">
								<p className="font-size-14 mb-0 text-color">Unit Type</p>
								<h5 className="text-primary fw-bold">
									{resaleDetails.unit_type?.name[`${AuthData.lang}`]}
								</h5>
							</div>
						</Col>
					</Row>
					<Row className="mt-5 justify-content-center">
						{checkAvailability !== 2 && (
							<Col md={6}>
								<div className="text-center">
									<p className="bask-font fs-1 text-primary fw-medium">
										{t("Check Availability")}
									</p>
									<p className="mb-0 fw-light pb-4 font-size-18 text-primary text-uppercase">
										Kindly Click on the Check Availability button to make sure
										that the unit is available,
									</p>
									<button
										className={`btn w-50 mb-2 py-3 text-center ${
											checkAvailability == 1 ? "btn-secondary" : "btn-primary"
										}`}
										disabled={checkAvailability === 1 || loading ? true : false}
										onClick={() => handleCheckAvailability()}>
										{t("Check Availability")}
									</button>
								</div>
							</Col>
						)}
						{checkAvailability === 2 && (
							<Col md={6}>
								<div className="text-center">
									<p className="bask-font fs-1 mb-1 text-primary fw-medium">
										{t("The Unit Is Available")}
									</p>
									<p className="mb-0 fw-light pb-4 font-size-18 text-primary text-uppercase">
										THIS UNIT IS AVAILABLE YOU CAN BUY IT NOW
									</p>
									<button
										className={`btn w-50 mb-2 py-3 text-center m-auto br-50 ${
											checkAvailability === 2 ? "btn-primary" : "btn-secondary"
										}`}
										disabled={checkAvailability !== 2 ? true : false}
										style={{
											display: checkAvailability !== 2 ? "none" : "block",
											background: "var(--primary-color)",
											borderColor: "var(--primary-color)",
										}}
										onClick={() => setBuyModal(true)}>
										{t("Buy the Unit")}
									</button>
								</div>
							</Col>
						)}
					</Row>
				</Container>
			</div>

			<BuyUnitModal
				modal={buyModal}
				setModal={setBuyModal}
				propsList={props}
				details={resaleDetails}
				unitType="resale"
			/>
			<CheckAvailabilityModal
				modal={checkAvailabilityModal}
				setModal={() => props.history.push(`/resales`)}
			/>
			<CallModal
				modal={callModal}
				setModal={setCallModal}
				phone={resaleDetails?.sales_rep?.phone}
			/>
			<MessageModal
				modal={messageModal}
				setModal={setMessageModal}
				item={resaleDetails}
				type="resale"
			/>
		</div>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default ResaleBuyDetailsPage;
